import i18n from '../i18n';

/** Summani "1 234 567 so'm" ko'rinishida (valyuta birligi joriy tilga qarab). */
export function formatSom(amount: number | null | undefined): string {
  const v = amount ?? 0;
  return `${v.toLocaleString('ru-RU').replace(/,/g, ' ')} ${i18n.t('currency.som')}`;
}

/** Qisqa summa (grafik o'qi uchun): 20 000 000 → "20 mln". Birliklar joriy tilga qarab. */
export function formatSomShort(amount: number | null | undefined): string {
  const v = amount ?? 0;
  const abs = Math.abs(v);
  const dec = i18n.language?.slice(0, 2) === 'en' ? '.' : ',';
  const trim = (n: number) => n.toFixed(1).replace(/\.0$/, '').replace('.', dec);
  if (abs >= 1e9) return `${trim(v / 1e9)} ${i18n.t('currency.billion')}`;
  if (abs >= 1e6) return `${trim(v / 1e6)} ${i18n.t('currency.million')}`;
  if (abs >= 1e3) return `${Math.round(v / 1e3)} ${i18n.t('currency.thousand')}`;
  return String(v);
}

/**
 * Telefonni "+998 90 123-45-67" ko'rinishida. Format tanimasa — kirishni O'ZGARTIRMASDAN
 * qaytaradi (chet el raqami, niqoblangan `+998 *** *** 45 67`, to'liq bo'lmagan kiritma).
 *
 * MUHIM: qisqartirish (`slice`) uzunlik tekshiruvidan KEYIN emas, umuman bo'lmasligi kerak.
 * Ilgari `.replace(/^998/, '').slice(0, 9)` prefiksni ko'r-ko'rona kesar edi va
 * `+7 900 123 45 67` (Rossiya) → `+998 79 001-23-45` degan SOXTA raqam yasardi:
 * `slice` doim 9 ta raqam qaytargani uchun quyidagi himoya hech qachon ishlamasdi.
 * Mobil ilovadagi mantiq bilan aynan bir xil.
 */
export function formatPhone(v?: string | null): string {
  if (!v) return '—';
  const digits = v.replace(/\D/g, '');
  const d = digits.length === 12 && digits.startsWith('998') ? digits.slice(3) : digits;
  if (d.length !== 9) return v;
  return `+998 ${d.slice(0, 2)} ${d.slice(2, 5)}-${d.slice(5, 7)}-${d.slice(7, 9)}`;
}

/**
 * Toshkent (Asia/Tashkent = doimiy UTC+5) bo'yicha hafta kuni: 1=Dushanba .. 7=Yakshanba.
 * Brauzer mintaqasiga bog'lanmaydi — chet elda ochilgan panelda ham "bugun" maktabdagi
 * kun bilan bir xil bo'ladi (backend `lib/dates.ts` dagi tzDowIso bilan mos).
 */
export function tzDowIso(base: Date = new Date()): number {
  const tz = new Date(base.getTime() + 5 * 60 * 60 * 1000);
  return ((tz.getUTCDay() + 6) % 7) + 1;
}

/** Toshkent kuni "YYYY-MM-DD" — backend `lib/dates.ts` dagi tzDateKey bilan mos (kunlik soatbay kaliti). */
export function tzDateKey(d: string | Date): string {
  return new Date(new Date(d).getTime() + 5 * 60 * 60 * 1000).toISOString().slice(0, 10);
}

/** Sanani "DD.MM.YYYY" ko'rinishida. */
export function formatDate(d: string | Date | null | undefined): string {
  if (!d) return '—';
  const date = typeof d === 'string' ? new Date(d) : d;
  return date.toLocaleDateString('ru-RU');
}

/** Sana + soat: "DD.MM.YYYY HH:mm" (brauzer mahalliy vaqti — O'zbekistonda +05). */
export function formatDateTime(d: string | Date | null | undefined): string {
  if (!d) return '—';
  const date = typeof d === 'string' ? new Date(d) : d;
  const time = date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
  return `${date.toLocaleDateString('ru-RU')} ${time}`;
}

/** Nisbiy vaqt (joriy tilda): "hozirgina", "5 daqiqa oldin"..., eski bo'lsa sana. */
export function timeAgo(d: string | Date): string {
  const date = typeof d === 'string' ? new Date(d) : d;
  const min = Math.floor((Date.now() - date.getTime()) / 60000);
  if (min < 1) return i18n.t('timeAgo.justNow');
  if (min < 60) return i18n.t('timeAgo.min', { n: min });
  const hrs = Math.floor(min / 60);
  if (hrs < 24) return i18n.t('timeAgo.hour', { n: hrs });
  const days = Math.floor(hrs / 24);
  if (days < 7) return i18n.t('timeAgo.day', { n: days });
  return formatDate(date);
}

/** O'quvchi statusi kalitlari (yorliqlar i18n `studentStatus.*` orqali ko'rsatiladi). */
export const STUDENT_STATUS_KEYS = ['ACTIVE', 'INACTIVE', 'ON_LEAVE', 'GRADUATED', 'EXPELLED'] as const;
